import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import ArticleDetail from "./ArticleDetail";
import { useI18nField, useL } from "../locale/LocaleContext";

const Article = ({ data, title, style, showTitle=true
 }) => {
  const [selectedArticle, setSelectedArticle] = useState(null);
  const f = useI18nField(); // Firestore fields: f(doc, "field")
  const t = useL();         // UI label that might be {en,fr} or string

  const closeArticleDetail = () => setSelectedArticle(null);

  return (
    <section
      id="article-section"
      className="py-1- px-4 md:px-10 lg:px-16"
      style={{ fontFamily: "'Montserrat', sans-serif", ...style }}
    >
      {/* title prop could be a string or {en,fr} */}
      {showTitle && (<h1 className="text-3xl font-bold text-center mb-8">{t(title)}</h1>)}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {data.map((item, index) => {
          const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

          // Localized title from Firestore
          const name = f(item, "title"); // string or ""

          // First image from imageUrl (array or single string)
          const firstImg = Array.isArray(item.imageUrl)
            ? item.imageUrl[0]
            : item.imageUrl;

          // Alt text priority:
          // 1) explicit item.alt from Firestore
          // 2) localized title
          // 3) document id
          const altText = item.alt || name || item.id || "";

          return (
            <div
              ref={ref}
              key={item.id || index}
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? "translateY(0)" : "translateY(50px)",
                transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
                border: "1px solid #D3D3D3",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                padding: "3rem",
                cursor: "pointer",
              }}
              className="card service bg-white rounded-lg text-center flex flex-col justify-start items-center"
              onClick={() => setSelectedArticle(item)}
            >
              {firstImg && (
                <img
                  src={firstImg}
                  alt={altText}
                  style={{ maxWidth: "100%", height: "auto" }}
                />
              )}
              {/* show human title if present, else id */}
              <p className="mt-4 text-sm text-gray-800">{name || item.id}</p>
            </div>
          );
        })}
      </div>

      {selectedArticle && (
        <ArticleDetail article={selectedArticle} onClose={closeArticleDetail} />
      )}
    </section>
  );
};

export default Article;
